import compose from 'compose-function'

import { withRouter } from './with-router'
import { withIntl } from './with-intl'
import { withRecoil } from './with-recoil'

export const withProviders = compose(withRouter, withIntl, withRecoil)
